import { render, staticRenderFns } from "./BasicElementsSection.vue?vue&type=template&id=a084e76a&scoped=true"
import script from "./BasicElementsSection.vue?vue&type=script&lang=js"
export * from "./BasicElementsSection.vue?vue&type=script&lang=js"
import style0 from "./BasicElementsSection.vue?vue&type=style&index=0&id=a084e76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a084e76a",
  null
  
)

export default component.exports